import script from "./MyImages.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyImages.vue?vue&type=script&setup=true&lang=ts"

import "./MyImages.vue?vue&type=style&index=0&id=229fa665&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-229fa665"]])

export default __exports__